import { Component, OnInit, Input, ChangeDetectorRef, Inject } from '@angular/core';
import { ProgressbarService } from '../../services/progressbar.service';
import { AUTHORIZATOR_CONFIG } from '../../authorizator.config.token';
import { AuthorizatorConfig } from '../../authorizator.config';
import { AuthorizatorService } from '../../services/authorizator.service';

@Component({
  selector: 'angular-firebase-authotizator',
  templateUrl: './angular-firebase-authotizator.component.html',
  styleUrls: ['./angular-firebase-authotizator.component.scss']
})
export class AngularFirebaseAuthotizatorComponent implements OnInit {
  @Input() rootFirebasePath: string;
  public isUsersWaitBarShowing = false;
  public isRolesWaitBarShowing = false;
  constructor(
    public progressbarservice: ProgressbarService, private cd: ChangeDetectorRef,
    @Inject(AUTHORIZATOR_CONFIG) private authorizatorConfig: AuthorizatorConfig,
    private authroizatorservice: AuthorizatorService
  ) { }

  ngOnInit() {
    this.progressbarservice.usersWaitBar.subscribe(isShowing => {
      this.isUsersWaitBarShowing = isShowing;
      this.cd.detectChanges();

    });
    this.progressbarservice.rolesWaitBar.subscribe(isShowing => {
      this.isRolesWaitBarShowing = isShowing;
      this.cd.detectChanges();
    });
  }
}
